import React from 'react';
import styled from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';
import { FormattedMessage } from 'react-intl';
// import EthDiamondPlain from '../../static/eth-diamond-plain.svg.png';
// import EthRound from '../../static/eth-round-landing.svg';

import EthRound from '../../static/eth-diamond-plain.svg.png';
import { Text } from '../../components/Text';
import { Heading } from '../../components/Heading';
import { Link } from '../../components/Link';

const Container = styled.div`
  background: unset;
`;
const SubContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  max-width: ${p => p.theme.screenSizes.largest};
  width: 100%;
  margin: 0 auto;
  padding: 0 120px;
  @media only screen and (max-width: ${p => p.theme.screenSizes.largest}) {
    padding: 0 60px;
  }
`;
const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 20px;
  @media only screen and (max-width: ${p => p.theme.screenSizes.medium}) {
    display: none;
  }
`;

// adds an opaque eth logo behind the text on small screen sizes
const ContentContainer = styled.div`
  @media only screen and (max-width: ${p => p.theme.screenSizes.medium}) {
    :before {
      content: ' ';
      display: block;
      position: absolute;
      right: 60px;
      top: 35px;
      width: 250px;
      height: 400px;
      z-index: 1;
      opacity: 0.15;
      background-image: unset;
      background-repeat: no-repeat;
      background-position: 50% 0;
      -ms-background-size: cover;
      -o-background-size: cover;
      -moz-background-size: cover;
      -webkit-background-size: cover;
      background-size: cover;
    }
  }
`;
export const Introduction = (): JSX.Element => {
  return (
    <Container>
      <SubContainer className="py100 flex">
        <ImgContainer>
          <img src={EthRound} alt="" width="78px" />
        </ImgContainer>
        <ContentContainer>
          <ScrollAnimation animateIn="fadeIn" animateOnce>
            <Heading level={2} size="medium" color="blueDark" margin="none">
              <FormattedMessage defaultMessage="Validators and Endurance" />
            </Heading>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeInUp" animateOnce>
            <Text className="mt20 txt1">
              <FormattedMessage
                defaultMessage="This launchpad will help you become a validator, so you can play
                  an active part in Endurance's future. Validators are key to the
                  more secure, scalable, and sustainable Endurance we're building
                  together."
              />
            </Text>
            {/* <Link
              className="mt20 mb40"
              to="https://ethereum.org/en/roadmap/vision/"
            >
              <FormattedMessage defaultMessage="More on the Endurance vision" />
            </Link> */}
            <Text className="mt20 txt1">
              <FormattedMessage defaultMessage="By running a validator, you'll be responsible for securing the network and receive continuous payouts for actions that help the network reach consensus." />
            </Text>
            <Text className="mt20 txt1">
              <FormattedMessage defaultMessage="Endurance Staking network uses the Ethereum protocol. The content on this page is from the Ethereum staking launchpad page. You can refer to the source website for detailed technical descriptions." />
            </Text>
            <Link primary className="mt20" to="https://launchpad.ethereum.org">
              <FormattedMessage defaultMessage="Source website" />
            </Link>

            {/* NOTE: this section felt like there was a lot of repetition with the section below so have reframed to talk about validators in the context of the upgrades */}
          </ScrollAnimation>
        </ContentContainer>
      </SubContainer>
    </Container>
  );
};
